import { sleep } from '@/utils/sleep'
import { WebApp } from '@grammyjs/web-app'

export const playHapticSequence = async (
	type: (
		| 'error'
		| 'success'
		| 'warning'
		| 'soft'
		| 'rigid'
		| 'light'
		| 'medium'
		| 'heavy'
	)[]
) => {
	for (const t of type) {
		if (['error', 'success', 'warning'].includes(t)) {
			WebApp.HapticFeedback.notificationOccurred(
				t as 'error' | 'success' | 'warning'
			)
		} else {
			WebApp.HapticFeedback.impactOccurred(
				t as 'soft' | 'rigid' | 'light' | 'medium' | 'heavy'
			)
		}

		await sleep(100)
	}
}
